{
  "columnResizer": "Alat za promjenu veličine stupca",
  "loading": "Učitavam...",
  "loadingMore": "Učitavam još...",
  "resizeColumn": "Promijeni veličinu stupca",
  "sortAscending": "Sortiraj uzlazno",
  "sortDescending": "Sortiraj silazno"
}
